import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation',
  template: `
    <app-navigation></app-navigation>
    <router-outlet></router-outlet>
  `
})
export class CompatNavigationComponent {}



// WEBPACK FOOTER //
// ./src/compat/compat-navigation.component.ts